import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './app/App';
import reportWebVitals from './app/reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


reportWebVitals();
